module.exports = __webpack_public_path__ + "img/i_review_like_off.83900605.svg";